/*
 * Mother of Macros: section headings, jump bar and one-tap filters for the
 * one-time (à la carte) menu, Menu 1 (entrées). Rendered by snippets/alc-filter.liquid.
 *
 * - Headings: cards arrive in the collection's manual order (set by the n8n rotation).
 *   A heading is inserted wherever a card's data-section (product metafield
 *   custom.menu_section) changes. Nothing is re-sorted here.
 * - Jump bar: one button per section; tap scrolls to it; the current section is highlighted.
 * - Filters: Protein (any of), Diet (all of), Macros (all of). Groups combine with AND.
 *   Data comes from the card attributes printed by snippets/alc-product-card.liquid.
 * - Cards are never removed from the DOM, so a-la-carte.js (cart, quantities) is unaffected.
 */
(function () {
  'use strict';
  if (window.MOMAlcNavLoaded) return;
  window.MOMAlcNavLoaded = true;

  function slug(text) {
    return String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function headerBottom() {
    var header = document.querySelector('.section-header, sticky-header');
    if (!header) return 0;
    var position = window.getComputedStyle(header).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;
    var rect = header.getBoundingClientRect();
    return rect.bottom > 0 ? Math.round(rect.bottom) : 0;
  }

  function opaqueBackground(element) {
    var node = element.parentElement;
    while (node && node !== document.documentElement) {
      var color = window.getComputedStyle(node).backgroundColor;
      if (color && color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)') return color;
      node = node.parentElement;
    }
    return '#ffffff';
  }

  function Nav(nav) {
    this.nav = nav;
    this.scope = nav.getAttribute('data-alc-nav');
    // One nav can drive several grids that share its scope (the subscription builder
    // has an entrée grid and a dessert grid); the first one anchors the layout.
    this.grids = Array.prototype.slice.call(document.querySelectorAll('[data-filter-grid="' + this.scope + '"]'));
    this.grid = this.grids[0];
    this.jump = nav.querySelector('[data-alc-jump]');
    this.status = nav.querySelector('[data-alc-status]');
    this.statusText = nav.querySelector('[data-alc-status-text]');
    this.chips = Array.prototype.slice.call(nav.querySelectorAll('[data-filter-group]'));
    this.sections = [];
    this.state = { protein: [], diet: [], macro: [] };
    if (!this.grid) {
      nav.hidden = true;
      return;
    }
    this.cards = [];
    var cards = this.cards;
    this.grids.forEach(function (grid) {
      Array.prototype.push.apply(cards, grid.querySelectorAll('[data-alc-card]'));
    });
    this.buildSections();
    this.buildJump();
    this.bind();
    this.apply();
    this.nav.style.backgroundColor = opaqueBackground(this.nav);
  }

  // One line under each section title. Sections not listed here get a title only.
  var SECTION_NOTES = {
    'this-week-s-menu': 'Rotates weekly. Order by Saturday 11:59 PM PT.',
    'signature-entr-es': 'Customer favorites, on the menu every week.',
    'breakfast': 'High-protein mornings, ready in minutes.',
    'fresh-n-fit': 'Salads, snack boxes and wraps.',
    'bulk-macros': 'Proteins, carbs and veggies by the half pound.',
    'cakes-parfaits-more': 'Parfaits, cakes, cinnamon rolls and muffins.',
    'donuts': 'Protein donuts, dippers and donut holes.',
    'cookies-bars-bites': 'Grab-and-go protein snacks.',
    // Subscription builder (sections/sub-builder-enhance.liquid)
    'entr-es': 'Chef-made, macro-balanced entrées on every delivery.',
    'desserts': 'Protein donuts baked in-house in Sparks, NV.'
  };
  var NEW_SECTION = 'this-week-s-menu';

  // Any section whose name contains "limited" (e.g. "Halloween Limited Edition") is
  // seasonal: its note and badge say so.
  function isLimited(key) {
    return key.indexOf('limited') !== -1;
  }

  Nav.prototype.buildSections = function () {
    var scope = this.scope;
    var sections = this.sections;
    var current = null;
    var stripPrefix = this.nav.getAttribute('data-alc-strip-prefix') || '';
    var rotatingSection = this.nav.getAttribute('data-alc-rotating-section') || '';
    this.cards.forEach(function (card) {
      var name = (card.getAttribute('data-section') || '').trim();
      if (!name && rotatingSection && /(^|,\s*)rotating(\s*,|$)/.test(card.getAttribute('data-tags') || '')) {
        name = rotatingSection;
      }
      var key = slug(name);
      // Shorter card titles: drop the brand prefix shown in the page heading.
      if (stripPrefix) {
        var titleLink = card.querySelector('.new-pdp-prod-card-title');
        if (titleLink) {
          var text = titleLink.textContent.trim();
          if (text.toLowerCase().indexOf(stripPrefix.toLowerCase()) === 0) {
            titleLink.textContent = text.slice(stripPrefix.length).replace(/^[\s:\-–]+/, '');
          }
        }
      }
      if (name && (!current || current.name !== name)) {
        var heading = document.createElement('div');
        heading.className = 'alc-section-heading';
        heading.id = scope + '-' + key;
        var title = document.createElement('h3');
        title.className = 'alc-section-heading__title';
        title.textContent = name;
        heading.appendChild(title);
        var noteText = SECTION_NOTES[key] || (isLimited(key) ? 'Seasonal flavors, here for a limited time.' : '');
        if (noteText) {
          var note = document.createElement('p');
          note.className = 'alc-section-heading__note';
          note.textContent = noteText;
          heading.appendChild(note);
        }
        card.parentNode.insertBefore(heading, card);
        current = { name: name, heading: heading, cards: [], button: null };
        sections.push(current);
      }
      if (current) current.cards.push(card);
      // Badges sit bottom-left of the photo. Best Seller comes from the product
      // metafield custom.best_seller (set from real sales); New marks the rotating section.
      var labels = [];
      if (card.getAttribute('data-best-seller') === '1') labels.push(['alc-badge--best', 'Best seller']);
      if (key === NEW_SECTION) labels.push(['alc-badge--new', 'New this week']);
      if (isLimited(key)) labels.push(['alc-badge--limited', 'Limited time']);
      var media = card.querySelector('.alc-card-media');
      if (media && labels.length && !media.querySelector('.alc-badges')) {
        var stack = document.createElement('span');
        stack.className = 'alc-badges';
        labels.forEach(function (label) {
          var badge = document.createElement('span');
          badge.className = 'alc-new-badge ' + label[0];
          badge.textContent = label[1];
          stack.appendChild(badge);
        });
        media.appendChild(stack);
      }
    });
  };

  Nav.prototype.buildJump = function () {
    var self = this;
    if (!this.jump) return;
    if (this.sections.length < 2) {
      this.jump.hidden = true;
      return;
    }
    this.sections.forEach(function (section) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'alc-jump';
      button.textContent = section.name;
      button.addEventListener('click', function () { self.scrollTo(section.heading); });
      section.button = button;
      self.jump.appendChild(button);
    });
  };

  Nav.prototype.bind = function () {
    var self = this;
    this.chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pressed = chip.getAttribute('aria-pressed') !== 'true';
        chip.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        self.readState();
        self.apply();
        self.showResults();
      });
    });
    var clear = this.nav.querySelector('[data-alc-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        self.chips.forEach(function (chip) { chip.setAttribute('aria-pressed', 'false'); });
        self.readState();
        self.apply();
        self.showResults();
      });
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        self.updateTop();
        self.updateCurrent();
      });
      // The header animates in and out; measure again once it has settled.
      window.clearTimeout(self.settleTimer);
      self.settleTimer = window.setTimeout(settle, 400);
    }
    function settle() {
      self.updateTop();
      self.updateCurrent();
      if (self.updateFades) self.updateFades();
    }
    var header = document.querySelector('.section-header, sticky-header');
    if (header) {
      header.addEventListener('animationend', settle);
      header.addEventListener('transitionend', settle);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    // Swipeable rows (sections, filters): fade the edge that has more to scroll to,
    // so it is clear on a phone that the row continues.
    var rows = Array.prototype.slice.call(this.nav.querySelectorAll('.alc-nav__row'));
    function updateFades() {
      rows.forEach(function (row) {
        var max = row.scrollWidth - row.clientWidth;
        row.classList.toggle('has-more-right', max > 4 && row.scrollLeft < max - 4);
        row.classList.toggle('has-more-left', max > 4 && row.scrollLeft > 4);
      });
    }
    rows.forEach(function (row) { row.addEventListener('scroll', updateFades, { passive: true }); });
    window.addEventListener('resize', updateFades);
    document.addEventListener('alc:menu-shown', function () { window.setTimeout(updateFades, 60); });
    this.updateFades = updateFades;
    updateFades();
  };

  Nav.prototype.readState = function () {
    var state = { protein: [], diet: [], macro: [] };
    this.chips.forEach(function (chip) {
      if (chip.getAttribute('aria-pressed') === 'true') {
        state[chip.getAttribute('data-filter-group')].push(chip.getAttribute('data-filter-value'));
      }
    });
    this.state = state;
  };

  Nav.prototype.matches = function (card) {
    var state = this.state;
    var tags = (card.getAttribute('data-tags') || '').split(',').map(function (tag) { return tag.trim(); });
    if (state.protein.length && !state.protein.some(function (value) { return tags.indexOf(value) !== -1; })) {
      return false;
    }
    for (var i = 0; i < state.diet.length; i++) {
      if (card.getAttribute('data-' + state.diet[i]) !== '1') return false;
    }
    var protein = parseFloat(card.getAttribute('data-protein')) || 0;
    var calories = parseFloat(card.getAttribute('data-calories')) || 0;
    for (var j = 0; j < state.macro.length; j++) {
      if (state.macro[j] === 'protein40' && protein < 40) return false;
      if (state.macro[j] === 'cal400' && !(calories > 0 && calories < 400)) return false;
    }
    return true;
  };

  Nav.prototype.apply = function () {
    var self = this;
    var visible = 0;
    this.cards.forEach(function (card) {
      var show = self.matches(card);
      card.classList.toggle('alc-filtered-out', !show);
      if (show) visible += 1;
    });
    this.sections.forEach(function (section) {
      var any = section.cards.some(function (card) { return !card.classList.contains('alc-filtered-out'); });
      section.heading.classList.toggle('alc-filtered-out', !any);
      if (section.button) section.button.hidden = !any;
    });
    var active = this.state.protein.length + this.state.diet.length + this.state.macro.length;
    if (this.status) {
      this.status.hidden = active === 0;
      if (this.statusText) {
        this.statusText.textContent = visible === 0
          ? 'No meals match these filters.'
          : visible + (visible === 1 ? ' meal matches' : ' meals match');
      }
    }
    this.updateCurrent();
    if (this.updateFades) this.updateFades();
  };

  // After a filter change, if the visitor has scrolled past the top of the menu,
  // bring the first matching section into view so the results are not off screen.
  Nav.prototype.showResults = function () {
    var navRect = this.nav.getBoundingClientRect();
    var gridTop = this.grid.getBoundingClientRect().top;
    if (gridTop >= navRect.bottom) return;
    var first = this.sections.filter(function (section) {
      return !section.heading.classList.contains('alc-filtered-out');
    })[0];
    if (first) this.scrollTo(first.heading);
  };

  Nav.prototype.updateTop = function () {
    this.nav.style.setProperty('--alc-nav-top', headerBottom() + 'px');
  };

  Nav.prototype.offset = function () {
    return headerBottom() + this.nav.offsetHeight + 12;
  };

  // The site header hides while scrolling down and returns while scrolling up, so the
  // space it takes is only reserved when the jump goes up the page.
  Nav.prototype.scrollTo = function (heading) {
    var header = document.querySelector('.section-header, sticky-header');
    var headerHeight = header && window.getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
    var headingTop = heading.getBoundingClientRect().top + window.pageYOffset;
    var goingDown = headingTop > window.pageYOffset + this.nav.offsetHeight + headerHeight;
    var reserve = this.nav.offsetHeight + 12 + (goingDown ? 0 : headerHeight);
    window.scrollTo({ top: Math.max(0, headingTop - reserve), behavior: 'smooth' });
  };

  Nav.prototype.updateCurrent = function () {
    if (!this.sections.length || this.nav.offsetParent === null) return;
    var line = this.offset() + 48;
    var current = null;
    this.sections.forEach(function (section) {
      if (section.heading.classList.contains('alc-filtered-out')) return;
      if (section.heading.getBoundingClientRect().top <= line) current = section;
    });
    if (!current) {
      current = this.sections.filter(function (section) {
        return !section.heading.classList.contains('alc-filtered-out');
      })[0] || null;
    }
    var jump = this.jump;
    this.sections.forEach(function (section) {
      if (!section.button) return;
      var isCurrent = section === current;
      section.button.classList.toggle('is-current', isCurrent);
      if (isCurrent) {
        section.button.setAttribute('aria-current', 'true');
        if (jump && jump.scrollWidth > jump.clientWidth) {
          var left = section.button.offsetLeft - (jump.clientWidth - section.button.offsetWidth) / 2;
          if (Math.abs(jump.scrollLeft - left) > 4) jump.scrollTo({ left: left, behavior: 'smooth' });
        }
      } else {
        section.button.removeAttribute('aria-current');
      }
    });
  };

  // Phones hide the allergy notice inside the fixed order panel (see alc-menu-nav.css),
  // so a copy is placed once at the top of the menu, where every shopper sees it.
  function copyAllergyNotice(scope) {
    var menus = scope.querySelectorAll('[data-alc-menu]');
    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i];
      var notice = menu.querySelector('.alc-order__notice');
      var left = menu.querySelector('.new-pdp-left-wrapper');
      if (!notice || !left || left.querySelector('.alc-allergy-inline')) continue;
      var copy = notice.cloneNode(true);
      copy.className = 'alc-allergy-inline';
      left.insertBefore(copy, left.firstChild);
    }
  }

  // Desserts step: an always-visible "Back to Entrees" link inside the order panel,
  // next to the checkout button. It reuses the existing back action (a-la-carte.js),
  // and alc-menu-nav.css shows it on step 2 only.
  function addPanelBackLink(scope) {
    var menus = scope.querySelectorAll('[data-alc-menu]');
    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i];
      var panel = menu.querySelector('[data-alc-panel]');
      var source = menu.querySelector('.alc-back');
      var checkout = panel && panel.querySelector('.alc-checkout');
      if (!panel || !source || !checkout || panel.querySelector('.alc-order__back')) continue;
      var link = document.createElement('a');
      link.href = '#menu';
      link.className = 'alc-order__back';
      link.setAttribute('data-alc-action', 'back');
      link.textContent = '\u2190 ' + source.textContent.trim();
      checkout.parentNode.insertBefore(link, checkout.nextSibling);
    }
  }

  // Phones: the Tidio chat button sits at the bottom right, on top of the order panel's
  // main button. Tidio draws it inside its own shadow root, so a style is added there to
  // lift the closed button above the panel (the open chat window is not moved).
  // Tidio loads late, so this waits for its element to appear.
  function liftChatButton() {
    function tryLift() {
      var host = document.getElementById('tidio-chat');
      var root = host && host.shadowRoot;
      if (!root) return false;
      if (!root.getElementById('mom-alc-chat-lift')) {
        var style = document.createElement('style');
        style.id = 'mom-alc-chat-lift';
        style.textContent = '@media screen and (max-width: 749px) { #button.chat-closed { margin-bottom: 180px !important; } }';
        root.appendChild(style);
      }
      return true;
    }
    if (tryLift()) return;
    var observer = new MutationObserver(function () {
      if (tryLift()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 60000);
  }

  function init(scope) {
    copyAllergyNotice(scope);
    addPanelBackLink(scope);
    var navs = scope.querySelectorAll('[data-alc-nav]');
    for (var i = 0; i < navs.length; i++) {
      if (navs[i].hasAttribute('data-alc-nav-ready')) continue;
      navs[i].setAttribute('data-alc-nav-ready', '');
      new Nav(navs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  liftChatButton();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  // The menu panel can be revealed after load (plan step -> menu); refresh positions then.
  document.addEventListener('alc:menu-shown', function () {
    window.setTimeout(function () { window.dispatchEvent(new Event('scroll')); }, 50);
  });
})();

/*
 * Mother of Macros: point out the meal a visitor was looking at (Claude, Oct 2026).
 * The product page (assets/mom-pdp.js) saves mom_focus = {l: local variant id, n: nationwide
 * variant id} before sending the visitor through the ZIP and plan steps. When the one-time menu
 * shows, the matching card for their area is scrolled into view with a brief green glow. Used once, 30 min max.
 */
(function () {
  'use strict';
  if (window.MOMMenuFocusLoaded) return;
  window.MOMMenuFocusLoaded = true;

  function read() {
    try {
      var f = JSON.parse(sessionStorage.getItem('mom_focus') || 'null');
      if (!f || Date.now() - (f.ts || 0) > 30 * 60 * 1000) return null;
      return f;
    } catch (e) { return null; }
  }

  function style() {
    if (document.getElementById('mom-menu-focus-style')) return;
    var css = document.createElement('style');
    css.id = 'mom-menu-focus-style';
    css.textContent =
      '.mom-focus-card{border-radius:12px;animation:momFocusGlow 2.6s ease-out .5s 1 both}' +
      '@keyframes momFocusGlow{0%{box-shadow:0 0 0 0 rgba(77,124,54,0)}15%{box-shadow:0 0 0 4px rgba(77,124,54,.85)}55%{box-shadow:0 0 0 4px rgba(77,124,54,.85)}100%{box-shadow:0 0 0 4px rgba(77,124,54,0)}}' +
      '@media (prefers-reduced-motion:reduce){.mom-focus-card{animation:none}}';
    document.head.appendChild(css);
  }

  function apply() {
    if (!document.documentElement.classList.contains('alc-view-menu')) return false;
    var f = read();
    if (!f) return true;
    var zone = document.querySelector('[data-alc-zone]:not([hidden])');
    if (!zone) return false;
    var id = zone.getAttribute('data-alc-zone') === 'local' ? f.l : f.n;
    try { sessionStorage.removeItem('mom_focus'); } catch (e) {}
    if (!id) return true;
    var card = zone.querySelector('[data-alc-card][data-id="' + id + '"]');
    if (!card) return true;
    var menu = zone.closest('[data-alc-menu]');
    var panel = card.closest('[data-alc-step-panel]');
    if (menu && panel && panel.getAttribute('data-alc-step-panel') !== menu.getAttribute('data-step')) {
      var cont = menu.querySelector('[data-alc-action="continue"]');
      if (cont && panel.getAttribute('data-alc-step-panel') === '2') cont.click();
    }
    style();
    card.classList.add('mom-focus-card');
    window.setTimeout(function () { card.classList.remove('mom-focus-card'); }, 4000);
    window.setTimeout(function () {
      var header = document.querySelector('.section-header, sticky-header');
      var offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var top = card.getBoundingClientRect().top + window.pageYOffset - offset - 70;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, 350);
    return true;
  }

  function start() {
    if (apply()) return;
    document.addEventListener('alc:menu-shown', function once() {
      window.setTimeout(apply, 120);
      document.removeEventListener('alc:menu-shown', once);
    });
    var obs = new MutationObserver(function () { if (apply()) obs.disconnect(); });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    window.setTimeout(function () { obs.disconnect(); }, 10 * 60 * 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
